import { htmlFrom } from '@common/utils';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { RichTextBoxSerialization } from './RichTextBoxSerialization';
import { RichTextBoxUtils } from './RichTextBoxUtils';

type RichTextDisplayProps = {
  value?: string | null | undefined;
  asPlainText?: boolean;
} & React.HtmlHTMLAttributes<HTMLSpanElement>;

export const RichTextDisplay = observer(
  ({ asPlainText, value, ...attrs }: RichTextDisplayProps) => {
    const { className, ...remainingAttrs } = attrs;
    const text = React.useMemo(() => {
      if (value == null) return null;

      const richTextNodes = RichTextBoxSerialization.parseHtmlToRichText(value);
      const serializeResult =
        RichTextBoxSerialization.serializeRichTextValueToString(richTextNodes);
      if (asPlainText) {
        if (serializeResult.isPlainText) return serializeResult.value;
        return RichTextBoxUtils.serializeRichTextToPlainText(richTextNodes);
      } else {
        return serializeResult.value;
      }
    }, [value, asPlainText]);

    if (text == null)
      return (
        <span
          className={classNames('richtextbox-content display', className)}
          {...remainingAttrs}
        >
          -
        </span>
      );
    return (
      <span
        className={classNames('richtextbox-content display', className)}
        {...remainingAttrs}
      >
        {htmlFrom(text ?? '')}
      </span>
    );
  },
);
